PLAYER p1 20 You
PLAYER p2 20 Practice partner
ACTIVE p1
p1 battlefield Forest
p1 hand Forest
p1 hand Grizzly Bears
p1 library Forest | copies=20
p2 library Forest | copies=20
